


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { WorkShiftForm } from '@/models/config'

// Components
import { FormCreateEditWorkShift } from '@/components/config'

@Component({
    name: 'ModalCreateEditWorkShift',
    components: {
        FormCreateEditWorkShift
    }
})
export default class ModalCreateEditWorkShift extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) workShift!: WorkShiftForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear Nuevo Turno de Trabajo'
        }
        return 'Editar Turno de Trabajo'
    }
}
